// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ny-z","tooltipWrapper":"oy-z","icon":"py-z","tooltip":"qy-z","content":"ry-z"};